import React, { useContext, useMemo, useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import Layout from '@/layouts/Default'
import { usePromotionsData } from '@saatva-bits/pattern-library.modules.promotions'
import { Loader } from '@saatva-bits/pattern-library.components.loader'
import { CartContext } from '@/store/cart'
import Cart from './Sections/CartSection'
import CartEmpty from './Sections/CartEmpty'
import RecommendedProducts from './Sections/RecommendedProductsSection'
import SavedForLater from './Sections/SavedForLaterSection'
import OrderSummarySection from './Sections/OrderSummarySection'
import ExtendModal from '@/components/CartItem/Extend/modal'
import styles from './styles.module.scss'
import { ProductDetailModal } from '@saatva-bits/pattern-library.components.product-detail-modal'
import { useProductDetailModal } from '@saatva-bits/pattern-library.components.product-detail-modal/dist/store/modal-context'
import { isExcludedItem } from '@/utils/product'
import { pushStrikethroughPricing } from '@/utils/analytics'

const CartView = (props) => {
    const previousPriceDiscountLabels = useRef(null)
    const {
        cart,
        isLoading,
        initialLoading,
        savedForLater,
        removedItem,
        addItemToCart,
        configureItem,
        updateItemInCart,
        recommendedProducts,
        discountsSummary
    } = useContext(CartContext)
    const detailModal = useProductDetailModal()
    const cartItems = useMemo(() => {
        if (cart?.items) {
            return cart.items.filter((item) => !isExcludedItem(item)) 
        }
        return []
    }, [cart])
    useEffect(() => {
        if (cartItems.length > 0) {
            const recoStripProducts = recommendedProducts?.length ? recommendedProducts : []
            detailModal.setProducts([...cartItems, ...recoStripProducts])
        }
    }, [cartItems, recommendedProducts])
    useEffect(() => {
        const currentpriceDiscountLabels = JSON.stringify(cart?.priceDiscounts.map((discount) => discount.label)) // Used to compare cart discounts and only fire the event when the discounts update.
        if (!previousPriceDiscountLabels.current || previousPriceDiscountLabels.current !== currentpriceDiscountLabels) {
            pushStrikethroughPricing(discountsSummary)
            previousPriceDiscountLabels.current = currentpriceDiscountLabels
        }
    }, [discountsSummary, cart?.priceDiscounts])

    const promotionsData = usePromotionsData()
    const sitewidePromo = promotionsData.sitewidePromo
    const [isExtendModalVisible, setIsExtendModalVisible] = useState(false)
    const cartIsEmpty = [...cartItems, ...savedForLater].length === 0
    const containerClass = classNames('container', { [styles.container]: !cartIsEmpty, [styles.containerWithoutItems]: cartIsEmpty })
    const cartTotalItems = cart ? cart.totalItems : 0
    const updatedProps = { ...props, cartTotalItems: cartTotalItems }

    return (
        <Layout {...updatedProps}>
            <div className={containerClass}>
                { (initialLoading || isLoading) && <Loader className={styles.cartLoader} isFullScreen><h2>Updating your information</h2></Loader>}
                {cartIsEmpty ?
                    (!initialLoading && !isLoading) && <CartEmpty itemRemoved={removedItem}/>
                    :
                    <>
                        <div className={styles.sections}>
                            <Cart
                                sitewidePromo={sitewidePromo}
                                setIsExtendModalVisible={setIsExtendModalVisible}
                                itemRemoved={removedItem}
                                cartTotalItems={cartTotalItems}
                            />
                            <RecommendedProducts />
                            <SavedForLater savedForLaterItems={savedForLater} />
                        </div>
                        <OrderSummarySection />
                    </>
                }
            </div>
            {!cartIsEmpty &&
                <>
                    <ExtendModal isExtendModalVisible={isExtendModalVisible} setIsExtendModalVisible={setIsExtendModalVisible}/>
                    <ProductDetailModal
                        onAddToCart={addItemToCart}
                        onConfigureItem={configureItem}
                        onUpddateItem={updateItemInCart}
                    />
                </>
            }
        </Layout>
    )
}

export default CartView
